import React from 'react';
import { formatByKey, EM_DASH } from '../../../lib/measurableDisplay';

/* The mark cells for one group.

   Layout is the one deliberate divergence from the apps: they scroll a group
   horizontally past 3 marks; web wraps at >=640px so a 6-mark group uses the
   width, and falls back to scrolling below that. Horizontal scroll is a worse
   interaction with a mouse than with a thumb. See me.css .me-cells.

   A mark is { key, label, value, unit, verified }. There is no `source` —
   get_measurables does not return provenance, so the web cell cannot show the
   camp/PR line the apps do. */

const Seal = () => (
  <svg className="me-cell__seal" width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 2l2.4 1.8 3 .3 1 2.8 2.3 1.9-1.1 2.8 1.1 2.8-2.3 1.9-1 2.8-3 .3L12 22l-2.4-1.8-3-.3-1-2.8L3.3 15l1.1-2.8L3.3 9.4l2.3-1.9 1-2.8 3-.3z" />
    <path d="M10.6 15.2l-2.6-2.6 1.1-1.1 1.5 1.5 3.8-3.8 1.1 1.1z" fill="#fff" />
  </svg>
);

export default function StatGroupCard({ marks, onOpen }) {
  return (
    <div className="me-cells">
      {marks.map((m) => {
        const filled = m.value != null && m.value !== '';
        const shown = filled ? formatByKey(m.key, m.value) : EM_DASH;
        const unit = filled && m.unit ? ` ${m.unit}` : '';
        return (
          <button
            type="button"
            key={m.key}
            className={`me-cell${filled ? '' : ' me-cell--empty'}`}
            onClick={onOpen}
            aria-label={filled
              ? `${m.label}: ${shown}${unit}${m.verified ? ', verified' : ''}`
              : `${m.label}: not logged yet`}
          >
            <span className="me-cell__value">
              {shown}{unit}
              {filled && m.verified && <Seal />}
            </span>
            <span className="me-cell__label">{m.label}</span>
          </button>
        );
      })}
    </div>
  );
}
